import React, { Suspense } from 'react';
import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { LoadingSpinner } from './components/LoadingSpinner';

// Lazy load all components consistently
const LegacyAppWrapper = React.lazy(() => import('./components/LegacyAppWrapper'));
const CareersApp = React.lazy(() => import('./microfrontends/CareersAppRouterless'));
const ClustersApp = React.lazy(() => import('./microfrontends/ClustersAppRouterless'));
const CounselorPortalApp = React.lazy(() => import('./microfrontends/CounselorPortalAppRouterless'));
const DiscussionGuideApp = React.lazy(() => import('./microfrontends/DiscussionGuideAppRouterless'));
const FeedbackApp = React.lazy(() => import('./microfrontends/FeedbackAppWithRouter'));
// const FeedbackApp = React.lazy(() => import('./microfrontends/FeedbackApp'));

// Wrapper component to handle Suspense for lazy loaded components
const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>
);

const ROOT_ROUTES = {
  BASE_ROUTE: '/',
  HOME: 'home',
};

const baseRoutes: RouteObject[] = [
  {
    path: ROOT_ROUTES.HOME,
    element: (
      <SuspenseWrapper>
        <LegacyAppWrapper route={ROOT_ROUTES.HOME} />
      </SuspenseWrapper>
    ),
  },
  // {
  //   path: 'aptitudes',
  //   // index: true,
  //   children: [
  //     {
  //       index: true,
  //       element: (
  //         <SuspenseWrapper>
  //           <FeedbackApp />
  //         </SuspenseWrapper>
  //       ),
  //     },
  //     {
  //       path: ':id',
  //       element: (
  //         <SuspenseWrapper>
  //           <FeedbackApp />
  //         </SuspenseWrapper>
  //       ),
  //     },
  //   ],
  {
    path: 'aptitudes',
    element: (
      <SuspenseWrapper>
        <LegacyAppWrapper route='aptitudes' />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'aptitudes/:id',
    element: (
      <SuspenseWrapper>
        <FeedbackApp />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'assessment/:batteryType/start',
    element: (
      <SuspenseWrapper>
        <LegacyAppWrapper route='assessment-test' />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'assessment/:batteryType/uh_oh',
    element: (
      <SuspenseWrapper>
        <LegacyAppWrapper route='assessment-error' />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'bridge-activities',
    element: (
      <SuspenseWrapper>
        <LegacyAppWrapper route='bridge-activities' />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'careers/*',
    element: (
      <SuspenseWrapper>
        <CareersApp />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'clusters/*',
    element: (
      <SuspenseWrapper>
        <ClustersApp />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'describing_you/*',
    element: (
      <SuspenseWrapper>
        <DiscussionGuideApp />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'logout',
    element: (
      <SuspenseWrapper>
        <LegacyAppWrapper route='logout' />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'organizations/*',
    element: (
      <SuspenseWrapper>
        <CounselorPortalApp />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'public/careers/*',
    element: (
      <SuspenseWrapper>
        <CareersApp isPublic={true} />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'bookmarks',
    element: (
      <SuspenseWrapper>
        <FeedbackApp />
      </SuspenseWrapper>
    ),
  },
  {
    path: 'assessments/*',
    async lazy() {
      const { UserBioRedirect } = await import('./components/UserBioRedirect');
      return {
        Component: UserBioRedirect,
      };
    },
    errorElement: <div>Error</div>,
  },
];

const localeRoutes: RouteObject[] = [
  {
    path: ':locale',
    children: baseRoutes,
  },
];

export const mainRoutes: RouteObject[] = [
  {
    path: ROOT_ROUTES.BASE_ROUTE,
    element: (
      <SuspenseWrapper>
        <LegacyAppWrapper route={ROOT_ROUTES.BASE_ROUTE} />
      </SuspenseWrapper>
    ),
    index: true,
  },
  {
    path: ROOT_ROUTES.BASE_ROUTE,
    children: [...baseRoutes, ...localeRoutes],
  },
];

export const router = createBrowserRouter(mainRoutes, {
  future: {
    v7_relativeSplatPath: true,
    v7_normalizeFormMethod: true,
    v7_fetcherPersist: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});
